import { ErrorResponse } from "./datetime";
import { WENT_WRONG } from "../consts/formats";

const coerceMessage = (value: unknown): string | null =>
  typeof value === "string" && value.trim() ? value : null;

export const extractErrorMessage = (error: unknown): string => {
  if (!error) return WENT_WRONG;

  // If error is a plain string
  const directMessage = coerceMessage(error);
  if (directMessage) return directMessage;

  // Common axios shapes
  if (typeof error === "object" && error !== null) {
    const { response, message } = error as ErrorResponse;
    const respMsg =
      coerceMessage(response?.data?.message) ??
      coerceMessage(response?.data?.error?.message);
    if (respMsg) return respMsg;

    if (coerceMessage(message)) return message as string;

    if (typeof message === "string") {
      try {
        const parsed = JSON.parse(message);
        const parsedMessage = coerceMessage(parsed?.message);
        if (parsedMessage) return parsedMessage;
      } catch {
        // ignore parse errors and fall through
      }
      return message;
    }
  }

  // last resort
  return WENT_WRONG;
};
